import { useEffect, useRef, useCallback } from 'react'
import consumer from '@/lib/actionCable'
import type { Subscription } from '@rails/actioncable'

export function useActionCable(
  conversationId: number | null,
  onReceived: (data: unknown) => void,
) {
  const subscriptionRef = useRef<Subscription | null>(null)
  const onReceivedRef = useRef(onReceived)
  onReceivedRef.current = onReceived

  useEffect(() => {
    // Don't subscribe without a conversation
    if (!conversationId) return

    const subscription = consumer.subscriptions.create(
      { channel: 'AndrzejChannel', conversation_id: conversationId },
      { received: (data: unknown) => onReceivedRef.current(data) }
    )
    subscriptionRef.current = subscription

    return () => {
      subscription.unsubscribe()
      subscriptionRef.current = null
    }
  }, [conversationId])

  return subscriptionRef
}
